<template>
  <CModal
    @mtdclosemodal="mtdClose"
    :show="boo_modal"
    :title="title"
    :size="'lg'"
    :centered="false"
    :btn_cancel="true"
    :btn_ok="true"
    :booTitile="true"
  >
    <CRow>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <cSelect
          :options="floors"
          label="Seleccione Piso"
          :value="floor_id"
          @input="floor_id = $event.target.value"
          @change="mtdLoadBoxesByFloor"
        />
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <cSelect
          :options="boxes"
          label="Seleccione Caja"
          :value="box"
          @input="box = $event.target.value"
          @change="filterBox"
        />
      </CCol>
      <!-- <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 mt-0 text-center">
          <label class="form-label text-center"
            ><strong>Billetes</strong></label
          >
          <div v-for="(item, index) in billetes" :key="index" class="">
            <CInput
              :append="item.total == 0 ? '0.00' : item.total"
              v-model="item.cantidad"
              disabled
            >
              <template #prepend-content>{{ item.label }}</template>
            </CInput>
          </div>
        </div>
      </CCol>
      <CCol>
        <div class="col-md-12 col-lg-12 col-sm-12 col-xs-12 text-center">
          <label class="form-label text-center"><strong>Monedas</strong></label>
          <div v-for="(item, index) in monedas" :key="index" class="">
            <CInput
              :append="item.total == 0 ? '0.00' : item.total"
              placeholder="0"
              disabled
              v-model="item.cantidad"
            >
              <template #prepend-content>{{ item.label }}</template>
            </CInput>
          </div>
        </div>
      </CCol> -->
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <CInput
          type="number"
          label="Monto de apertura"
          v-model="process.initial"
          @keyup="validatePositive('monto')"
        />
      </CCol>
      <CCol xs="12" sm="12" md="12" lg="6" xl="6">
        <CInput type="text" label="Observación" v-model="process.observation" />
      </CCol>
    </CRow>
    <template #footer>
      <button @click="mtdClose" class="btn btn-sm btn-danger">
        <i class="fa fa-times" />&nbsp;Cerrar
      </button>
      <button @click="mtd_action" class="btn btn-info btn-sm">
        <i class="fas fa-comment-dollar"></i> Aperturar
      </button>
      &nbsp;
    </template>
  </CModal>
</template>

<script>
import CModal from "../../../shared/modals/cModalFormCom.vue";
import { mapActions } from "vuex";
export default {
  name: "c-open-bead-modal",
  components: {
    CModal,
  },
  data() {
    return {
      prefix: "beads",
      bead: {
        box_id: "",
        user_id: this.$store.getters.get__user_id,
        campu_id: this.$store.getters.get_campu.id,
        company_id: this.$store.getters.get_company.id,
        floor_id: null,
        expense: "",
        income: "",
        turned: "",
        card: "",
        retirement: "",
        status_open: "",
        status_close: "",
        deposit: "",
        authorize: "",
        state: "",
      },
      process: {
        box_id: "",
        observation: "",
        initial: 0,
      },
      newBead: true,
      /** arqueo */
      billetes: [],
      monedas: [],
      /** select box */
      boxes: [],
      box: null,
      /** select floor */
      floors: [],
      floor_id: null,
    };
  },
  props: {
    title: String,
    boo_modal: Boolean,
  },
  watch: {
    boo_modal(newVal) {
      if (newVal == true) {
        this.mtdLoadFloors();
        this.mtdGetBox();
        // this.filterBox();
      }
    },
  },
  methods: {
    ...mapActions(["get", "post"]),
    mtdClose() {
      this.resetFormData();
      this.$emit("closeModalOpenBead");
    },
    resetFormData() {
      this.bead = {
        box_id: "",
        user_id: this.$store.getters.get__user_id,
        campu_id: this.$store.getters.get_campu.id,
        floor_id: null,
        status_open: "",
        status_close: "",
        state: "",
      };
      this.floor_id = null;
      this.box = null;
      this.boxes = [];
    },
    mtd_action() {
      this.process.billetes = this.billetes;
      this.process.monedas = this.monedas;
      // Incluir floor_id en el bead si está seleccionado
      if (this.floor_id) {
        this.bead.floor_id = this.floor_id;
      }

      // Manejar errores de forma silenciosa para evitar logs en consola
      this.post({
        url: this.$store.getters.get__url + "/" + this.prefix + "/store",
        token: this.$store.getters.get__token,
        params: {
          bead: this.bead,
          process: this.process,
        },
      })
        .then((response) => {
          if (response.statusCode == 200) {
            let color = "success";
            let message = "REGISTRADO CORRECTAMENTE";
            // Reseteamos la data
            this.resetFormData();
            this.$emit("save");
            Swal.fire({
              title: message,
              icon: color,
            });
          } else {
            Swal.fire({
              title: response.message,
              icon: "warning",
            });
          }
        })
        .catch((error) => {
          let errorMessage =
            error.response?.data?.message ||
            error.message ||
            "Error inesperado";

          Swal.fire({
            title: errorMessage,
            icon: "error",
          });
        });
    },
    filterBox() {
      if (this.box > 0) {
        this.get({
          url:
            this.$store.getters.get__url +
            "/" +
            this.prefix +
            "/filterBox/" +
            this.box,
          token: this.$store.getters.get__token,
        })
          .then((response) => {
            let box = response.data.data;
            this.newBead = response.data.new;
            this.process.box_id = this.box;
            this.bead.box_id = this.box;
            /** last bead */
            if (response.data.lastBead) {
              let jsonCierre = JSON.parse(
                response.data.lastBead.transaction.json_cierre
              );
              this.billetes = jsonCierre.billetes;
              this.monedas = jsonCierre.monedas;
              this.process.initial = response.data.initialPrevious;
            } else {
              this.billetes = [];
              this.monedas = [];
              this.process.initial = 0;
            }
          })
          .catch((erros) => {});
      } else {
        this.billetes = [];
        this.monedas = [];
        this.process.initial = 0;
      }
    },
    validatePositive(field) {
      let sanitizedValue = event.target.value.replace(/[^0-9.]/g, "");
      const decimalCount = sanitizedValue.split(".").length - 1;
      if (decimalCount > 1) {
        sanitizedValue = sanitizedValue.slice(0, -1);
      }
      const decimalIndex = sanitizedValue.indexOf("."); // Limitar a dos decimales
      if (decimalIndex !== -1) {
        const decimalPart = sanitizedValue.substring(decimalIndex + 1);
        sanitizedValue = `${sanitizedValue.substring(
          0,
          decimalIndex
        )}.${decimalPart.substring(0, 2)}`;
      }
      this.bead[field] = sanitizedValue;
    },
    mtdLoadFloors() {
      this.get({
        url:
          this.$store.getters.get__url +
          "/floors/byCampu/" +
          this.$store.getters.get_campu.id,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          // El endpoint devuelve ApiResponse con data
          const floorsData = response.data || response;
          this.floors = [
            { value: null, label: "TODOS LOS PISOS" },
            ...floorsData.map((item) => ({
              label: item.name,
              value: item.id,
            })),
          ];
        })
        .catch((erros) => {});
    },
    mtdLoadBoxesByFloor() {
      // Limpiar selección de caja cuando cambia el piso
      this.box = null;
      this.bead.box_id = "";
      this.process.box_id = "";
      this.billetes = [];
      this.monedas = [];
      this.process.initial = 0;

      // Cargar cajas filtradas por piso
      this.mtdGetBox();
    },
    mtdGetBox() {
      let url =
        this.$store.getters.get__url +
        "/" +
        this.prefix +
        "/getbox/" +
        this.$store.getters.get_campu.id;

      // Agregar floor_id como query parameter si está seleccionado
      if (this.floor_id) {
        url += "?floor_id=" + this.floor_id;
      }

      this.get({
        url: url,
        token: this.$store.getters.get__token,
      })
        .then((response) => {
          this.boxes = [
            { value: null, label: "ESCOJA UNA CAJA" },
            ...response.map((item) => ({
              label: item.name,
              value: item.id,
            })),
          ];
        })
        .catch((erros) => {});
    },
  },
};
</script>

<style scoped>
</style>
